import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteTiposUsuarios, updateTiposUsuarios } from "../../api/axios";
import { connect } from 'react-redux';
import { toast } from "react-toastify";
import ModalItem from "../General/Modal";
import GoBackArrow from "../General/GoBackArrow";
import { fetchTipoUsuarios } from '../../actions/usuariosActions';
import BigSpinner from "../General/BigSpinner";

function TipoUsuarioEditWrapper(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    return <TipoUsuarioEdit {...props} navigate={navigate} id={id} />;
}

class TipoUsuarioEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            showModal: false,
            loading: false,
            saving: false
        };
        this.descripcionInputRef = React.createRef();
    }

    async componentDidMount() {
        const { id } = this.props;
        const idParsed = parseInt(id);

        this.setState({ loading: true });

        try {
            const response = await this.props.fetchTipoUsuarios(idParsed);

            this.setState({
                descripcion: response?.data[0]?.descripcion ?? "",
                loading: false
            });

        } catch (error) {
            toast.error("No se pudo cargar el tipo de usuario");
            this.goBack();
        }
    }


    onSubmit = async (e) => {
        e.preventDefault();

        if (!this.state.descripcion) {
            toast.error("La descripción es obligatoria.");
            return;
        }

        this.setState({ saving: true });

        try {
            let request = {
                Id: parseInt(this.props.id),
                Descripcion: this.state.descripcion
            };

            await updateTiposUsuarios(request); 

            toast.success("Tipo de usuario actualizado.");
            this.goBack();
        } catch (err) {
            toast.error("Error al actualizar el tipo de usuario.");
        } finally {
            this.setState({ saving: false });
        }
    };

    onDelete = async (id) => {
        const idParsed = parseInt(id);

        try {
            await deleteTiposUsuarios(idParsed);

            toast.success("Tipo de usuario eliminado.");
            this.goBack();
        } catch (err) {
            toast.error("Error al eliminar el tipo de usuario.");
        } finally {
            this.setState({ showModal: false });
        }
    };

    goBack = async () => {
        await this.props.fetchTipoUsuarios();
        this.props.navigate("/Usuarios/TipoUsuarios");
    }

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    render() {
        if (this.state.loading) return <BigSpinner />;

        return (
            <div className="container card">
                <div className="row justify-content-between align-items-center card-body p-4">

                    <div className="col-10 col-md-5 mb-4">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">Editar Tipo de Usuario</h4>
                    </div>

                    <form className="col-12 form-horizontal form-material" onSubmit={this.onSubmit}>

                        <div className="form-group">
                            <div className="row justify-content-evenly">

                                <div className="col-12 col-md-7 mb-3 mb-md-0">
                                    <label className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        value={this.state.descripcion}
                                        onChange={this.myChangeHandler}
                                        id="firstName"
                                        className="form-control"
                                        ref={this.descripcionInputRef}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center justify-content-center mb-3 text-center mt-3">

                            <button
                                type="submit"
                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el tipo de usuario?"
                                onDelete={() => this.onDelete(this.props.id)}
                                centered
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                            />

                            <button
                                type="button"
                                onClick={this.goBack}
                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                            >
                                Cancelar
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default connect(null, { fetchTipoUsuarios })(TipoUsuarioEditWrapper);